import React from 'react';

const SwitchInput = ({ input, label, className, meta: { touched, error, warning, invalid } }) => {
  return (      
        <div className="switch-container">
          <label className="switch">
            <input {...input} type="checkbox" className={`${className}${touched && invalid ? ' has-danger' : ''}`}/>
            <span className="slider round"></span>
          </label>
          <span className="switch-label">{label}</span>
          {touched && ((error && <span className="input-error">{error}</span>) || (warning && <span className="input-warning">{warning}</span>))}
        </div>
  );
};

export default SwitchInput;